
import { TFunction } from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonProps, Icon, IconProps } from "semantic-ui-react";
import "./_EvaluationCheck.less"

export interface EvaluationCheckProps {
    enums: any[];
    value?: any;
    onChange: (value?: any) => void;
};


const getTextProps = (t: TFunction) => ({
    ok: t("Kunnossa"),
    notOk: t("Korjattavaa"),
    uknown: t("Ei tietoa"),
});

export const EvaluationCheck: React.FC<EvaluationCheckProps> = ({ enums, value, onChange }) => {

    const texts = getTextProps(useTranslation().t)
    const onItemClick: ButtonProps["onClick"] = (_1, { value: status }) => {
        onChange(status);
    };

    const renderItem = (text: string, enumValue: number, iconProps: IconProps) => (
        <div className="EvaluationCheck-item">
            <Button
                type="button"
                circular
                icon
                size="huge"
                value={enumValue}
                onClick={onItemClick}
                color={enumValue === value ? iconProps.color : undefined}
                active={enumValue === value}
            >
                <Icon {...iconProps} color={enumValue === value ? undefined : iconProps.color} />
            </Button>
            <label> {text} </label>
        </div>
    );

    return (
        <div className="EvaluationCheck-container">
            {renderItem(texts.ok, enums[1], { name: "check", color: "green" })}
            {renderItem(texts.notOk, enums[0], { name: "times", color: "red" })}
            {renderItem(texts.uknown, enums[2], { name: "question", color: "grey" })}
        </div>
    );
};
